import { feedFactoryAxios } from '../lib/axios';
import { Lang } from '../models';
import { InternalLocationItemModel } from '../models/Ndtrc';

const RESULTS_TO_SHOW = 25;

/**
 * The API returns trcItemDetails as a list of { lang, title, ... }, while the
 * form works with them keyed by language (see postNewEvent). Convert on the way
 * in, so nothing downstream has to know about both shapes.
 */
const externalToInternal = (external: any): InternalLocationItemModel => {
  const trcItemDetails: InternalLocationItemModel['trcItemDetails'] = {};
  (external.trcItemDetails || []).forEach((detail: any) => {
    if (detail?.lang) {
      trcItemDetails[detail.lang] = detail;
    }
  });

  return { ...external, trcItemDetails };
};

export const getLocationTitle = (
  location: InternalLocationItemModel,
  preferredLang?: Lang
): string => {
  const details = location.trcItemDetails || {};
  const primary = location.translations?.primaryLanguage;
  const candidates = [preferredLang, primary, Lang.NL, Lang.EN];

  for (const lang of candidates) {
    const title = lang && details[lang]?.title;
    if (title) {
      return title;
    }
  }

  const firstWithTitle = Object.values(details).find((detail) => detail?.title);
  return firstWithTitle?.title || 'Untitled location';
};

export const describeLocation = (location: InternalLocationItemModel): string => {
  const address = location.location?.address;
  if (!address) {
    return '';
  }
  const street = [address.street, address.housenr].filter(Boolean).join(' ').trim();
  return [street, address.city].filter(Boolean).join(', ');
};

export const fetchLocationsByQuery = async (
  query: string,
  userOrganisations?: string[] | null
): Promise<InternalLocationItemModel[]> => {
  const params = new URLSearchParams({
    size: String(RESULTS_TO_SHOW),
    page: '0',
    search: query.toLowerCase(),
    userorganisation: userOrganisations?.length ? userOrganisations.join(';') : '*',
    wfstatus: 'approved',
  });

  const res = await feedFactoryAxios.get(`/locations?${params.toString()}`);
  return (res.data?.results || []).map(externalToInternal);
};

export const fetchLocationById = async (
  id: string
): Promise<InternalLocationItemModel | null> => {
  const res = await feedFactoryAxios.get(`/locations/${encodeURIComponent(id)}`);
  return res.data ? externalToInternal(res.data) : null;
};
